export const defaultColor = '#007BFF';
